export class DialogModelSaleMedicines {
    constructor(
      public data: any
    ) {}
  }